// Compact topbar for narrow viewports. Hidden at md+. Hosts the
// workspace label + active page name and the user avatar. Sign-out
// lives in the Settings page.

import { useLocation } from 'react-router-dom';
import { Avatar } from '../components/Avatar.js';

interface MobileTopbarProps {
  userName: string;
  email?: string;
  photoUrl: string | null;
}

const PAGE_TITLES: Record<string, string> = {
  '/people': 'People',
  '/companies': 'Companies',
  '/dial': 'Lists',
  '/audit': 'Activity',
  '/colleagues': 'Colleagues',
  '/trash': 'Trash',
  '/settings': 'Settings'
};

export function MobileTopbar({ userName, email, photoUrl }: MobileTopbarProps) {
  const location = useLocation();
  const segment = '/' + location.pathname.split('/')[1];
  const pageTitle = PAGE_TITLES[segment];

  return (
    <header
      className="md:hidden surface border-b border-divider px-3 py-2 flex items-center gap-2 sticky top-0 z-20"
      aria-label="Top bar"
    >
      <div className="min-w-0 flex-1">
        <p className="text-[10px] uppercase tracking-widest text-muted">Personical</p>
        <p className="text-sm font-semibold text-strong truncate">
          Cloud Contacts{pageTitle ? `: ${pageTitle}` : ''}
        </p>
      </div>
      <span title={email ? `${userName} · ${email}` : userName}>
        <Avatar name={userName} photoUrl={photoUrl ?? undefined} size="sm" />
      </span>
    </header>
  );
}
